export const GET_SUGGESTION_REQUEST = "GET_SUGGESTION_REQUEST";
export const GET_SUGGESTION_SUCCESS = "GET_SUGGESTION_SUCCESS";
export const GET_SUGGESTION_FAILURE = "GET_SUGGESTION_FAILURE";
